import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from "recharts";

export default function ProgressRing({ value = 0, size = 180, color = "#EC4899", label, sublabel, testId }) {
  const data = [{ name: "v", value: Math.max(0, Math.min(100, value)) }];
  return (
    <div className="relative inline-block progress-ring-glow" data-testid={testId} style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart cx="50%" cy="50%" innerRadius="72%" outerRadius="100%" barSize={14} data={data} startAngle={90} endAngle={-270}>
          <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
          <RadialBar background={{ fill: "#F1EDE5" }} dataKey="value" cornerRadius={12} fill={color} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-serif text-4xl text-[#0B1E36]">{Math.round(value)}</div>
        {label && <div className="text-xs uppercase tracking-widest text-slate-500 mt-1">{label}</div>}
        {sublabel && <div className="text-xs text-slate-400 mt-0.5">{sublabel}</div>}
      </div>
    </div>
  );
}
